// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kRB0","tabsBox":"styles_tabsBox__2pdHa","createButton":"styles_createButton__bIBzh"};